// extracted by mini-css-extract-plugin
module.exports = {"section":"fullwidth-cta-module--section--3vN34","header":"fullwidth-cta-module--header--2NBd2","footer":"fullwidth-cta-module--footer--1O0t5"};